import React, { FunctionComponent } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate, sendTealiumEvent } from "../../helpers";
import routes from "../../app/routes";

interface GoBackProps extends RouteComponentProps {
  mobileOnly?: boolean;
}

const GoBack: FunctionComponent<GoBackProps> = ({ history, mobileOnly }) => {
  const t = useTranslate();

  return (
    <Button
      className={`planComparisonSummary__backBtn ds-c-button--primary-alt-outline${
        mobileOnly ? " mct-u-mobile-only" : ""
      }`}
      onClick={(): void => {
        // istanbul ignore next: tested elsewhere
        sendTealiumEvent("Find Plans - Compare", "Back to Results");
        history.push(routes.searchResults);
      }}
    >
      {t("app.terms.back_to_results")}
    </Button>
  );
};

export default withRouter(GoBack);
